<template>
  <div class="page-intro">
    <div class="banner"></div>
    <div class="g-wrap">
      <div class="g-tabs">
        <router-link :to="`${$subsitePrefix}/ah/${item.id}`" :class="{ active: item.id == activeTab }" v-for="item in tabList" :key="item.id">{{ item.text }}</router-link>
      </div>
    </div>
    <keep-alive>
      <component :is="activeComp"></component>
    </keep-alive>
  </div>
</template>

<script>
import PanelAdmission from "./components/Admission";
import PanelHiring from "./components/Hiring";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tabList: [
        {
          id: "admission",
          comp: PanelAdmission.name,
          text: "招生平台"
        },
        {
          id: "hiring",
          comp: PanelHiring.name,
          text: "企业招聘"
        }
      ],
      activeTab: "admission",
      activeComp: PanelAdmission.name
    };
  },
  components: {
    [PanelAdmission.name]: PanelAdmission,
    [PanelHiring.name]: PanelHiring
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    init() {
      const path = this.$route.path.split("/");
      const id = path[path.length - 1];
      const matched = this.tabList.filter(item => item.id === id);
      if (matched && matched.length) {
        this.activeTab = matched[0].id || PanelAdmission.id;
        this.activeComp = matched[0].comp || PanelAdmission.comp;
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.page-intro {
  .banner {
    background: url(~assets/img/feature/admissionsHiring/banner.png) no-repeat
      center top;
    background-size: 100% 100%;
    height: 160px;
  }
}
</style>
